import { Injectable } from '@angular/core';
import {
  PlatformInformationService,
  PlatformInformationServiceConfigurator
} from './platform-information.service';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AssetPathService {
  constructor(
    private configuration: PlatformInformationServiceConfigurator,
    private platformservice: PlatformInformationService
  ) {}
  /**
   * turns e.g images/customer-award.png to https://www.alpy.com/assetz/assets/images/customer-award.png
   * @param relativeUrl the relative path to the asset without 'assets'. Start without slash
   * @param fromAngular is the asset hosted by angular? (assetz) or not?
   * @param platformSpecific if true, will search under the platformspecific subfolder
   */
  getAssetsPath(
    relativeUrl: string,
    fromAngular = false,
    platformSpecific = false,
    folder = '/assets/'
  ): string {
    if (this.platformservice.getHostname() && relativeUrl) {
      if (platformSpecific) {
        switch (this.platformservice.getCurrentPlatformShortcode()) {
          case 'sb': {
            folder += 'snowbrainer/';
            break;
          }
          case 'sf': {
            folder += 'slopefox/';
            break;
          }
          case 'pf': {
            folder += 'pistenfuchs/';
            break;
          }
          case 'sm': {
            folder += 'skimarie/';
            break;
          }
          case 'mc': {
            folder += 'locationskimoinscher/';
            break;
          }
          case 'df': {
            folder += 'skidiscountfr/';
            break;
          }
          case 'du': {
            folder += 'skidiscountcouk/';
            break;
          }
          case 'bp': {
            folder += 'bestpriceskirental/';
            break;
          }
          case 's2': {
            folder += 'simplytoski/';
            break;
          }
        }
      }

      if (fromAngular) {
        // return https://www.alpy.com/assetz/assets/YOURPATH.extension
        if (['ssr', 'ssr-beta', 'beta', 'prod', 'node', 'cloudflare'].includes(this.configuration.env)) {
          folder = '/assetz' + folder; // production special folder
        }
        return Location.joinWithSlash(folder, relativeUrl);
      }

      return Location.joinWithSlash(
        this.platformservice.getHostname(),
        Location.joinWithSlash(folder, relativeUrl)
      );
    }
  }
}
